import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import * as Styled from './styled';
import type { NavigationProps } from './types';

export const Navigation: FC<NavigationProps> = (props) => {
  const { navbarLinkCategories, onLogoutClick, isMobile } = props;
  const { translate } = useTranslation();

  return (
    <>
      <Styled.NavbarLinkContainer>
        {navbarLinkCategories.map((category, index) => (
          <Styled.NavbarLinkCategory key={index} bottomPinned={category.bottomPinned ?? false}>
            {!!category.label && <Styled.NavbarLinkTitle>{category.label}</Styled.NavbarLinkTitle>}
            {category.links.map((link, linkIndex) => (
              <Styled.NavbarLink
                key={linkIndex}
                onClick={() => !(link.disabled ?? false) && link.onClick?.()}
                active={link.active ?? false}
                highlight={link.highlight ?? false}
                disabled={link.disabled ?? false}
                data-tip={link.tooltip}
                {...(!link.disabled && isMobile
                  ? { htmlFor: 'mobile-header-drawer', as: 'label' }
                  : {})}
              >
                {!!link.icon && <Styled.NavbarLinkIcon icon={link.icon} />}
                <Styled.NavbarLinkLabel>{link.label}</Styled.NavbarLinkLabel>
                {!!link.notifications && <Styled.NotificationDot />}
              </Styled.NavbarLink>
            ))}
          </Styled.NavbarLinkCategory>
        ))}
      </Styled.NavbarLinkContainer>

      <Styled.SideLogoutButtonContainer>
        <Styled.SideLogoutButton
          onClick={onLogoutClick}
          color="dark"
          iconLeft={<Styled.NavbarLinkIcon icon="sign-out-alt" />}
        >
          {translate('mt.header.loggingOut')}
        </Styled.SideLogoutButton>
      </Styled.SideLogoutButtonContainer>
    </>
  );
};
